<template>
  <div class="flat-card mt-3">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h6 class="mb-0" style="font-weight:600;color:#0f172a;">Cohort Retention</h6>
        <small class="text-secondary">% of signup cohort that placed orders each month</small>
      </div>
      <button class="btn btn-outline-secondary" @click="fetch" :disabled="loading">
        <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>

    <div v-if="loading" class="text-center py-3">
      <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div v-else-if="cohorts.length === 0" class="text-center text-secondary py-3">
      <small>Not enough data yet</small>
    </div>

    <div v-else class="table-responsive">
      <table class="table mb-0" style="font-size:.78rem;">
        <thead>
          <tr>
            <th style="min-width:90px;">Cohort</th>
            <th class="text-center" style="min-width:52px;">Size</th>
            <th
              v-for="(_, k) in maxMonths"
              :key="k"
              class="text-center"
              style="min-width:44px;"
            >
              M+{{ k }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in cohorts" :key="row.month">
            <td class="font-weight-bold text-nowrap align-middle">{{ row.month }}</td>
            <td class="text-center align-middle text-secondary">{{ row.cohort_size }}</td>
            <td
              v-for="(pct, k) in paddedRetention(row)"
              :key="k"
              class="text-center align-middle"
              :style="cellStyle(pct)"
              :title="pct !== null ? pct + '%' : '—'"
            >
              <span v-if="pct !== null" style="font-size:.75rem;font-weight:500;">{{ pct }}%</span>
              <span v-else class="text-secondary" style="font-size:.7rem;">–</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Legend -->
    <div class="d-flex align-items-center mt-2" style="gap:6px;font-size:.72rem;">
      <span class="text-secondary">Retention:</span>
      <span v-for="(stop, i) in legend" :key="i" class="d-flex align-items-center" style="gap:3px;">
        <span class="rounded" :style="{ background: stop.color, width:'12px', height:'12px', display:'inline-block' }"></span>
        <span>{{ stop.label }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminCohortGrid',

  data() {
    return {
      loading: false,
      cohorts: [],
    };
  },

  computed: {
    maxMonths() {
      return Math.max(1, ...this.cohorts.map(r => r.retention.length));
    },

    legend() {
      return [
        { color: 'rgba(13,110,253,.15)', label: '≥80%' },
        { color: '#f1f5f9', label: '50–79%' },
        { color: 'rgba(220,53,69,.12)', label: '<50%' },
        { color: '#f8fafc', label: 'N/A' },
      ];
    },
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/admin/charts/cohort-retention');
        this.cohorts = data;
      } finally {
        this.loading = false;
      }
    },

    paddedRetention(row) {
      const arr = [];
      for (let k = 0; k < this.maxMonths; k++) {
        arr.push(row.retention[k] !== undefined ? row.retention[k] : null);
      }
      return arr;
    },

    cellStyle(pct) {
      if (pct === null) return { background: '#f8fafc' };
      if (pct >= 80)    return { background: 'rgba(13,110,253,.15)', color: '#0d6efd' };
      if (pct >= 50)    return { background: '#f1f5f9', color: '#334155' };
      return                   { background: 'rgba(220,53,69,.12)', color: '#dc3545' };
    },
  },
};
</script>

<style scoped>
.flat-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 14px;
  padding: 20px;
}
</style>
